import { DEFAULT_PAGINATION_OPTIONS } from 'components/Pagination/constants';
import { DEFAULT_TABLE_PAGESIZE } from 'components/Table/contants';
import { useHistory } from 'react-router-dom';

export const KEY: string = 'pagesize';

const invalidPageSize = (pageSize: number): boolean =>
  !DEFAULT_PAGINATION_OPTIONS.map((x) => x.value).includes(pageSize);

type response = {
  pageSize: number;
  searchParams: string | null;
};

/**
 * Get value of `pagesize` search term from URLSearchParams.
 */
export const usePageSizeSearchParam = (): response => {
  const history = useHistory();
  let updateSearchParam: boolean = false;

  const searchParams = new URLSearchParams(history.location.search);
  const pagesize = searchParams.get(KEY) ?? DEFAULT_TABLE_PAGESIZE.toString();

  if (searchParams.get(KEY) === null) {
    updateSearchParam = true;
  }

  let pageSize: number = Number.parseInt(pagesize);

  if (invalidPageSize(pageSize) || Number.isNaN(pageSize)) {
    pageSize = DEFAULT_TABLE_PAGESIZE;
    updateSearchParam = true;
  }

  if (updateSearchParam) {
    searchParams.set(KEY, pageSize.toString());
    history.push({ search: searchParams.toString() });
  }

  return {
    pageSize: pageSize,
    searchParams: searchParams.toString(),
  };
};
